export const IconFacebook40: {
  name: 'icon_facebook_40-fe66d6adc35b'
} = {
  name: 'icon_facebook_40-fe66d6adc35b'
}
